// extracted by mini-css-extract-plugin
export default {"quotationMark":"quotationMark__quotationMark--HD5QA"};